// biome-ignore lint/suspicious/noExplicitAny: ESLint migration
declare let navigator: any

export const copyToClipboard = async (text: string) => {
  return navigator.clipboard.writeText(text)
}
